import { UIMMatchmakingController } from './matchmaking_selection/UIMMatchmakingController.ts';
import { showSimpleDialog } from '../../../../../../shared/scripts/ui_popup/showSimpleDialog.ts';
export class UIMHomepageController {
    onHomepageHide() {
        this.matchmakingController.removeSearchingScreen();
    }
    showMatchmakingError(error) {
        this.matchmakingController.stopSearching();
        showSimpleDialog({
            title: {
                key: 'strings:popups.errors.matchmakingError.rankedMode'
            },
            body: error.description
        });
    }
    constructor(){
        this.matchmakingController = new UIMMatchmakingController();
    }
}
